import { zIndex } from "@nova/constants"
import classNames from "classnames"
import { noop } from "nodash"
import { ReactNode } from "react"
import { ModalContainerPosition } from "../modals/module"

type FullScreenProps = {
    clickHandler?: () => void
    children?: ReactNode
    positionOverrides?: ModalContainerPosition
    blackoutBackground?: boolean
}

/**
 * centers content in the visible screen and blurs out the background via opacity
 *
 * note: tailwind styles automatically apply opacity to all child elements, so to avoid the modal being too opaque, we stack
 * content above the blur layer
 *
 * @returns
 */
export const FullScreen = ({
    children,
    clickHandler = noop,
    positionOverrides = ModalContainerPosition.Center,
    blackoutBackground,
}: FullScreenProps) => {
    return (
        <div
            className={classNames(
                "fixed top-0 left-0 right-0 bottom-0 w-full h-screen  overflow-hidden flex flex-col items-center",

                positionOverrides
            )}
            style={{ zIndex: zIndex.HighPriorityModal }}
            onClick={clickHandler}
        >
            {/* the content, floats above all in the center */}
            <div className="flex flex-col items-center justify-center opacity-100 z-50">
                {children}
            </div>
            {/* the opacity background is one z-level below the content */}
            <div
                className={classNames(
                    "fixed top-0 left-0 right-0 bottom-0 overflow-hidden opacity-75 h-full w-full z-40",
                    { "bg-black/40": blackoutBackground }
                )}
            />
        </div>
    )
}

export default FullScreen
